import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const PaymentFailed = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const orderId = searchParams.get('order_id');
  const errorMessage = searchParams.get('error');

  const handleRetryPayment = () => {
    navigate('/checkout');
  };

  const handleContinueShopping = () => {
    navigate('/');
  };

  const handleViewCart = () => {
    navigate('/cart');
  };

  const handleContactSupport = () => {
    window.location.href = 'mailto:support@yourdomain.com?subject=Payment Failed - Order ' + (orderId || 'Unknown');
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card shadow-sm">
            <div className="card-body text-center p-5">
              <div className="mb-4">
                <div 
                  style={{
                    width: '80px',
                    height: '80px',
                    backgroundColor: '#dc3545',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto',
                    fontSize: '40px',
                    color: 'white'
                  }}
                >
                  ✕
                </div>
              </div>
              
              <h1 className="text-danger mb-3">Payment Failed</h1>
              <p className="lead mb-4">
                Unfortunately, your payment could not be processed. No charges have been made to your card.
              </p>

              {errorMessage && (
                <div className="alert alert-danger mb-4">
                  <strong>Error Details:</strong> {decodeURIComponent(errorMessage)}
                </div>
              )}

              {orderId && (
                <div className="bg-light p-3 rounded mb-4">
                  <small className="text-muted">Order ID: <strong>{orderId}</strong></small>
                  <br />
                  <small className="text-muted">This order was not completed</small>
                </div>
              )}

              <div className="alert alert-info">
                <h6>Common Reasons for Payment Failure:</h6>
                <ul className="list-unstyled mb-0 text-start">
                  <li>• Insufficient funds in your account</li>
                  <li>• Expired or invalid card information</li>
                  <li>• Card declined by your bank</li>
                  <li>• Network or technical issues</li>
                  <li>• Security restrictions on your card</li>
                </ul>
              </div>

              <div className="alert alert-warning">
                <h6>What You Can Do:</h6>
                <ul className="list-unstyled mb-0 text-start">
                  <li>• Check your card details and try again</li>
                  <li>• Try a different payment method</li>
                  <li>• Contact your bank if the card should work</li>
                  <li>• Choose "Collection Only" to pay later</li>
                </ul>
              </div>

              <div className="mt-4">
                <button 
                  className="btn btn-danger btn-lg me-3"
                  onClick={handleRetryPayment}
                >
                  Try Payment Again
                </button>
                <button 
                  className="btn btn-outline-secondary btn-lg me-3"
                  onClick={handleViewCart}
                >
                  View Cart
                </button>
                <button 
                  className="btn btn-outline-primary btn-lg"
                  onClick={handleContinueShopping}
                >
                  Continue Shopping
                </button>
              </div>

              <div className="mt-4 pt-3 border-top">
                <h6>Need Help?</h6>
                <p className="text-muted mb-2">
                  If you continue to experience issues, our support team is here to help.
                </p>
                <button 
                  className="btn btn-outline-danger"
                  onClick={handleContactSupport}
                >
                  Contact Support
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;